import React, { Component } from 'react';
import './style.css'
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import { Nav, NavItem, NavLink, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import {connect} from 'react-redux'
import {logout} from './../../redux/actions'

class Headers extends Component {
    state = { 
        dropdownOpen:false
    }

    toggle =()=> this.setState({dropdownOpen:!this.state.dropdownOpen})

    logout=()=>{
        this.props.logout()
    }

    render() { 
        return ( 
            <div className='col-12 bg-white-headers'>
                <Nav navbar>
                    <NavItem className='d-flex justify-content-end pt-3 text-white-header'>
                        {
                            this.props.isLogin?
                            <>
                                <UncontrolledDropdown setActiveFromChild className='mr-5'>
                                    <DropdownToggle tag="a" className="nav-link" caret>
                                        <AccountCircleIcon/>
                                        {this.props.username}
                                    </DropdownToggle>
                                    <DropdownMenu>
                                        <DropdownItem tag="a" onClick={this.logout} active>Logout</DropdownItem>
                                    </DropdownMenu>
                                </UncontrolledDropdown>
                            </>
                            :
                            null
                        }
                        <NavLink href="" className='mr-2'>
                            Help
                        </NavLink>
                    </NavItem>
                </Nav>
            </div>
         );
    }
}

const reduxProps=({Auth})=>{
    return{
        ...Auth
    }
}
 
export default connect(reduxProps,{logout})(Headers);